import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { StickyCards } from "@/components/StickyCards";
import { GlobalPaymentsQuoter } from "@/components/GlobalPaymentsQuoter";
import { CreateAccountBanner } from "@/components/CreateAccountBanner/CreateAccountBanner.component";
import CountriesGifEs from "@/assets/Gifs/countries_es.gif";
import CountriesGifEn from "@/assets/Gifs/countries_en.gif";
import SendolaPersonalMap from "@/assets/Img/sendola-personal-map.png";
import HappyCouple from "@/assets/Img/happy-couple.jpg";
import admLogo from "@/assets/Img/PartnersLogos/adm.png";
import marisolLogo from "@/assets/Img/PartnersLogos/marisol.png";
import unitellerLogo from "@/assets/Img/PartnersLogos/uniteller.png";
import corpayLogo from "@/assets/Img/PartnersLogos/corpay.png";
import tesoredLogo from "@/assets/Img/PartnersLogos/tesored.png";
import apprizaLogo from "@/assets/Img/PartnersLogos/appriza.png";
import gytLogo from "@/assets/Img/PartnersLogos/gyt.png";
import claroPayLogo from "@/assets/Img/PartnersLogos/claro_pay.png";
import finviarEnLogo from "@/assets/Img/PartnersLogos/finviar_en.png";
import finviarEsLogo from "@/assets/Img/PartnersLogos/finviar_es.png";
import martoriLogo from "@/assets/Img/PartnersLogos/martori_farms.png";
import interAmericanChamber from "@/assets/Img/PartnersLogos/inter-american-chamber-of-commerce.png";
import northEastChamber from "@/assets/Img/PartnersLogos/northeast-chamber-of-commerce.png";
import anierm from "@/assets/Img/PartnersLogos/anierm.png";
import costaFarmsLogo from "@/assets/Img/PartnersLogos/costa_farms.png";
import usiLogo from "@/assets/Img/PartnersLogos/usi.png";
import omnibusExpressLogo from "@/assets/Img/PartnersLogos/omnibus_express.png";
import omnibusDeMexicoLogo from "@/assets/Img/PartnersLogos/omnibus_de_mexico.png";
import FlagMexico from "@/assets/Img/Flags/flag-mexico.png";
import FlagGuatemala from "@/assets/Img/Flags/flag-guatemala.png";
import FlagCanada from "@/assets/Img/Flags/flag-canada.png";
import FlagSalvador from "@/assets/Img/Flags/flag-salvador.png";
import FlagNicaragua from "@/assets/Img/Flags/flag-nicaragua.png";
import FlagHonduras from "@/assets/Img/Flags/flag-honduras.png";
import FlagPanama from "@/assets/Img/Flags/flag-panama.png";
import FlagPortugal from "@/assets/Img/Flags/flag-portugal.png";
import FlagPolonia from "@/assets/Img/Flags/flag-poland.png";
import FlagColombia from "@/assets/Img/Flags/flag-colombia.png";
import FlagArgentina from "@/assets/Img/Flags/flag-argentina.png";
import FlagPhilipines from "@/assets/Img/Flags/flag-philipines.png";
import FlagVietnam from "@/assets/Img/Flags/flag-vietnam.png";
import FlagIndia from "@/assets/Img/Flags/flag-india.png";
import SendolaPayVideoEn from "@/assets/Video/sendolapay-video.mp4";
import SendolaPayVideoEs from "@/assets/Video/sendolapay-video-es.mp4";
import { Helmet } from "react-helmet-async";
import _Marquee from "react-fast-marquee";
const Marquee = ((_Marquee as any)?.default ?? _Marquee) as typeof _Marquee;
import { Button } from "@/components/Button";
import { isMobile } from "react-device-detect";
import classNames from "classnames";
import { QuoterLegalInfo } from "@/components/QuoterLegalInfo";
import { ExploreOurSolutionsBanner } from "@/components/ExploreOurSolutionsBanner";

const AuthUrl = import.meta.env.VITE_AUTH_DOMAIN;

export default function HomePage() {
  const [t, i18n] = useTranslation("global");
  const lang = i18n.language;

  const [showLegalInfo, setShowLegalInfo] = useState(false);
  const audioEnabled = useRef(false);

  const videoRefEn = useRef<HTMLVideoElement>(null);
  const videoRefEs = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const videoRef = lang === "en" ? videoRefEn : videoRefEs;
    const otherVideoRef = lang !== "en" ? videoRefEn : videoRefEs;
    if (otherVideoRef?.current && videoRef?.current) {
      videoRef.current.muted = otherVideoRef.current.muted;
      videoRef.current.volume = otherVideoRef.current.volume;
      videoRef.current.currentTime = otherVideoRef.current.currentTime;

      otherVideoRef.current.pause();
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          if (videoRef?.current && !isMobile) {
            videoRef.current.play().catch(() => {});

            if (!audioEnabled.current) {
              videoRef.current.muted = false;
              audioEnabled.current = true;
            }
          }
        } else {
          if (videoRef?.current && !isMobile) {
            videoRef.current.pause();
          }
        }
      },
      { threshold: 0.1 }
    );

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    return () => {
      observer.disconnect();
      if (videoRef.current) {
        videoRef.current.pause();
      }
    };
  }, [lang]);

  useEffect(() => {
    if (window && window.location?.hash) {
      const id = window.location.hash.replace("#", "");
      const element = document.getElementById(id);

      if (element) element.scrollIntoView();
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>SendolaPay Personal | Inicio</title>
      </Helmet>

      <div className="w-full">
        {/* Quoter */}
        <div className="flex flex-col items-center justify-start w-full min-h-[74rem] h-auto lg:min-h-[70rem] px-2 xs:px-6 lg:px-10 -mb-32 -translate-y-32 rounded-t-large pt-[9.5rem] pb-32 bg-gradient-to-br from-primary-100 to-white">
          {/* <p
            className="text-primary-900 text-2xl sm:text-3xl md:text-4xl text-center inner-span-bolden mb-6"
            dangerouslySetInnerHTML={{ __html: t("Home.HeadingTitle") }}
          /> */}

          <div className="w-full h-full flex flex-col-reverse lg:flex-row items-center justify-center gap-6 max-w-screen-xl">
            <div className="relative w-full h-full min-h-40 sm:min-h-44 md::min-h-52 lg:self-stretch lg:h-auto lg:w-1/2 rounded-xl overflow-hidden">
              <img
                className="absolute w-full h-full object-cover"
                src={HappyCouple}
                alt="gif countries"
              />
              <div className="absolute w-full h-full object-cover bg-gray-900/65" />
              <div className="absolute w-full h-full flex flex-col items-start justify-center gap-2 lg:gap-8 p-4 sm:p-8">
                <p
                  className="text-left text-white text-xl sm:text-3xl lg:text-4xl inner-span-bolden"
                  dangerouslySetInnerHTML={{ __html: t("Home.HeadingTitle") }}
                />
                <h2 className="text-3xl sm:text-4xl md:text-5xl 2xl:text-6xl font-semibold inline-block text-white mr-2.5">
                  {t("Home.ScrollCallout")}{" "}
                  {lang === "en" ? (
                    <img
                      className="h-28 sm:h-32 md:h-40 2xl:h-48 -my-8 sm:-my-10 md:-my-12 inline object-contain"
                      src={CountriesGifEn}
                      alt="gif countries"
                    />
                  ) : (
                    <img
                      className="h-28 sm:h-32 md:h-40 2xl:h-48 -my-8 sm:-my-10 md:-my-12 inline object-contain"
                      src={CountriesGifEs}
                      alt="gif countries"
                    />
                  )}
                </h2>
              </div>
            </div>

            <div className="w-full h-full lg:w-1/2">
              <GlobalPaymentsQuoter
                showLegalInfo={() => setShowLegalInfo(true)}
              />
            </div>
          </div>
        </div>

        <div className="flex w-full justify-center px-6 lg:px-10 pt-4 lg:pt-6 -translate-y-20 rounded-t-large bg-white">
          <div className="w-full max-w-screen-xl flex flex-col items-center justify-center gap-6 sm:gap-8">
            <div className="w-full flex flex-col lg:flex-row">
              <div
                id="countries"
                className="flex flex-col gap-2 sm:gap-4 w-full lg:w-[34%] flex-shrink-0 py-6"
              >
                <div className="w-full">
                  <p className="text-4xl max-w-none sm:max-w-[80%] lg:max-w-none sm:text-6xl lg:text-5xl md:min-w-96 font-semibold">
                    {t("Home.CountriesSection.Title")}
                  </p>
                </div>

                <p className="text-lg sm:text-xl md:text-2xl font-medium w-full max-w-[28rem] lg:max-w-[19rem]">
                  {t("Home.CountriesSection.Subtitle")}
                </p>

                <div className="flex gap-8 items-center">
                  <div className="flex flex-col items-center md:gap-2">
                    <p className="text-7xl sm:text-8xl text-blue-600 font-bold">
                      14
                    </p>
                    <p className="text-lg sm:text-xl md:text-2xl font-medium">
                      {t("Home.CountriesSection.Countries")}
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-center w-full lg:w-[66%] h-auto flex-shrink-0">
                <img
                  src={SendolaPersonalMap}
                  className="w-full xl:px-2 object-contain lg:-my-10"
                  alt="Reach Map"
                />
              </div>
            </div>

            <div className="hidden w-full md:inline-flex flex-wrap justify-center items-end gap-4">
              <div className="flex gap-8 flex-shrink-0">
                <div className="flex flex-col">
                  <div className="flex w-fit flex-row items-center border-[3px] border-gray-300 rounded-full">
                    <p className="w-fit col-span-2 px-4 text-base sm:text-xl lg:text-2xl font-semibold">
                      {t("Countries.America")}:
                    </p>
                    <div className="flex">
                      <div className="flex items-center gap-3 w-fit h-full py-3 px-2">
                        <img
                          className="w-10 h-10 lg:w-12 lg:h-12 rounded-full object-cover"
                          src={FlagMexico}
                        />
                        <img
                          className="w-10 h-10 lg:w-12 lg:h-12 rounded-full object-cover"
                          src={FlagGuatemala}
                        />
                        <img
                          className="w-10 h-10 lg:w-12 lg:h-12 rounded-full object-cover"
                          src={FlagCanada}
                        />
                        <img
                          className="w-10 h-10 lg:w-12 lg:h-12 rounded-full object-cover"
                          src={FlagSalvador}
                        />
                        <img
                          className="w-10 h-10 lg:w-12 lg:h-12 rounded-full object-cover"
                          src={FlagNicaragua}
                        />
                        <img
                          className="w-10 h-10 lg:w-12 lg:h-12 rounded-full object-cover"
                          src={FlagHonduras}
                        />
                        <img
                          className="w-10 h-10 lg:w-12 lg:h-12 rounded-full object-cover"
                          src={FlagPanama}
                        />

                        <img
                          className="w-10 h-10 lg:w-12 lg:h-12 rounded-full object-cover"
                          src={FlagColombia}
                        />
                        <img
                          className="w-10 h-10 lg:w-12 lg:h-12 rounded-full object-cover"
                          src={FlagArgentina}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex gap-8 flex-shrink-0">
                <div className="flex flex-col">
                  <div className="flex items-center border-[3px] border-gray-300 rounded-full">
                    <p className="w-fit px-6 text-base sm:text-xl lg:text-2xl font-semibold">
                      {t("Countries.Asia")}:
                    </p>
                    <div className="flex gap-3 w-fit h-full pr-4 py-3">
                      <img
                        className="w-10 h-10 lg:w-12 lg:h-12 rounded-full object-cover"
                        src={FlagIndia}
                      />
                      <img
                        className="w-10 h-10 lg:w-12 lg:h-12 rounded-full object-cover"
                        src={FlagPhilipines}
                      />
                      <img
                        className="w-10 h-10 lg:w-12 lg:h-12 rounded-full object-cover"
                        src={FlagVietnam}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex gap-8 flex-shrink-0">
                <div className="flex flex-col">
                  <div className="flex items-center border-[3px] rounded-full">
                    <p className="w-fit px-6 text-base sm:text-xl lg:text-2xl font-semibold">
                      {t("Countries.Europe")}:
                    </p>
                    <div className="flex gap-3 w-fit h-full py-3 pl-2 pr-4">
                      <img
                        className="w-10 h-10 lg:w-12 lg:h-12 rounded-full object-cover"
                        src={FlagPortugal}
                      />
                      <img
                        className="w-10 h-10 lg:w-12 lg:h-12 rounded-full object-cover"
                        src={FlagPolonia}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="md:hidden w-full rounded-full border-[3px] border-gray-300 h-20">
              <Marquee className="w-full h-full rounded-full">
                <div className="w-full flex justify-center items-center rounded-full">
                  <p className="col-span-2 pl-8 pr-2 text-base sm:text-xl font-semibold">
                    {t("Countries.America")}:
                  </p>
                  <img
                    className="w-10 h-10 lg:w-12 lg:h-12 rounded-full object-cover ml-2"
                    src={FlagMexico}
                  />
                  <img
                    className="w-10 h-10 lg:w-12 lg:h-12 rounded-full object-cover ml-2"
                    src={FlagGuatemala}
                  />
                  <img
                    className="w-10 h-10 lg:w-12 lg:h-12 rounded-full object-cover ml-2"
                    src={FlagCanada}
                  />
                  <img
                    className="w-10 h-10 lg:w-12 lg:h-12 rounded-full object-cover ml-2"
                    src={FlagSalvador}
                  />
                  <img
                    className="w-10 h-10 lg:w-12 lg:h-12 rounded-full object-cover ml-2"
                    src={FlagNicaragua}
                  />
                  <img
                    className="w-10 h-10 lg:w-12 lg:h-12 rounded-full object-cover ml-2"
                    src={FlagHonduras}
                  />
                  <img
                    className="w-10 h-10 lg:w-12 lg:h-12 rounded-full object-cover ml-2"
                    src={FlagPanama}
                  />
                  <img
                    className="w-10 h-10 lg:w-12 lg:h-12 rounded-full object-cover ml-2"
                    src={FlagColombia}
                  />
                  <img
                    className="w-10 h-10 lg:w-12 lg:h-12 rounded-full object-cover ml-2"
                    src={FlagArgentina}
                  />
                  <p className="col-span-2 pl-8 pr-2 text-base sm:text-xl font-semibold">
                    {t("Countries.Asia")}:
                  </p>
                  <img
                    className="w-10 h-10 lg:w-12 lg:h-12 rounded-full object-cover ml-2"
                    src={FlagIndia}
                  />
                  <img
                    className="w-10 h-10 lg:w-12 lg:h-12 rounded-full object-cover ml-2"
                    src={FlagPhilipines}
                  />
                  <img
                    className="w-10 h-10 lg:w-12 lg:h-12 rounded-full object-cover ml-2"
                    src={FlagVietnam}
                  />
                  <p className="col-span-2 pl-8 pr-2 text-base sm:text-xl font-semibold">
                    {t("Countries.Europe")}:
                  </p>

                  <img
                    className="w-10 h-10 lg:w-12 lg:h-12 rounded-full object-cover ml-2"
                    src={FlagPortugal}
                  />
                  <img
                    className="w-10 h-10 lg:w-12 lg:h-12 rounded-full object-cover ml-2"
                    src={FlagPolonia}
                  />
                </div>
              </Marquee>
            </div>

            <div className="flex justify-center items-center w-full">
              <Button
                size="lg"
                className="!bg-primary-500 py-5 !px-8 !text-base sm:!text-lg lg:!text-xl !font-normal"
                text={t("Home.CountriesSection.Button")}
                onClick={() => window.open(`${AuthUrl}/sign-up`, "_blank")}
              />
            </div>
          </div>
        </div>

        <div className="flex flex-col justify-center items-center p-6 lg:p-10 gap-8">
          {/* <div
            className={classNames(
              "flex relative justify-center bg-black h-fit overflow-hidden rounded-large mt-6 max-w-screen-xl",
              {
                "lg:h-fit lg:max-h-[720px]": true, // Desktop styles
              }
            )}
          >
            <img
              src={HeadingCover}
              alt={t("Home.SendMoney")}
              className="object-cover object-top w-full h-full select-none min-h-[30rem] md:min-h-[28rem] 2xl:min-h-[24rem]"
            />
            <div className="w-full h-full absolute bg-stone-950/60 flex flex-col justify-center items-center px-6">
              <h1
                className="text-3xl lg:text-4xl font-light inner-span-bolden text-white text-center"
                dangerouslySetInnerHTML={{ __html: t("Banners.AmericaGreat") }}
              />
              <p
                className="text-base lg:text-2xl text-white bg-primary-500 font-[500] py-3 md:py-4 px-6 md:px-10 rounded-full max-w-lg lg:max-w-screen-lg text-center mt-10"
                dangerouslySetInnerHTML={{ __html: t("Home.HeadingCallout") }}
              />
            </div>
          </div> */}

          <div className="w-full flex flex-col justify-center items-center max-w-screen-xl pb-8 gap-6 lg:gap-14">
            <p
              className="text-slate-800 text-2xl sm:text-3xl md:text-4xl text-center md:mt-6 inner-span-bolden"
              dangerouslySetInnerHTML={{ __html: t("Home.Video") }}
            />
            <div
              className={classNames(
                "rounded-2xl overflow-hidden h-auto w-full",
                {
                  hidden: lang !== "en",
                }
              )}
            >
              <video
                ref={videoRefEn}
                muted
                autoPlay
                loop
                playsInline
                controls
                height={1080}
                width={1920}
                disablePictureInPicture
                disableRemotePlayback
                className="w-full h-fit min-h-full max-w-full"
              >
                <source src={SendolaPayVideoEn} type="video/mp4" />
              </video>
            </div>
            <div
              className={classNames(
                "rounded-2xl overflow-hidden h-auto w-full",
                {
                  hidden: lang !== "es",
                }
              )}
            >
              <video
                ref={videoRefEs}
                muted
                autoPlay
                loop
                playsInline
                controls
                height={1080}
                width={1920}
                disablePictureInPicture
                disableRemotePlayback
                className="w-full h-fit min-h-full max-w-full"
              >
                <source src={SendolaPayVideoEs} type="video/mp4" />
              </video>
            </div>
          </div>
        </div>

        <div
          id="cards"
          className="flex flex-col items-center px-6 lg:px-10 rounded-t-large bg-gradient-to-b from-primary-100 to-white"
        >
          <div className="w-full max-w-screen-xl">
            <StickyCards />
          </div>

          <div className="w-full max-w-screen-xl md:mt-10 py-4 sm:py-6">
            <CreateAccountBanner
              title={t("Home.BankAccount.Title")}
              subtitle={t("Home.BankAccount.Subtitle")}
              disclaimer={t("Home.BankAccount.Disclaimer")}
              buttonText={t("Home.BankAccount.Button")}
            />
          </div>
        </div>

        <div
          id="partners"
          className="flex flex-col items-center px-8 sm:px-10 lg:px-20 py-14 lg:py-20 bg-[#fcfcfc]"
        >
          <div className="w-full h-full flex flex-col items-center justify-center gap-6 lg:gap-10 max-w-screen-xl">
            <h1 className="text-3xl md:text-4xl font-[500] text-center">
              {t("Partners.Title")}
            </h1>

            <div className="w-full flex flex-col justify-center items-center overflow-hidden">
              <Marquee>
                <img
                  className="h-12 2xl:h-16 w-auto object-contain mx-6 lg:mx-10"
                  src={admLogo}
                  alt="ADM Logo"
                />
                <img
                  className="h-14 2xl:h-16 w-auto object-contain mx-6 lg:mx-10"
                  src={marisolLogo}
                  alt="MariSol Logo"
                />
                <img
                  className="h-6 2xl:h-7 w-auto object-contain mx-6 lg:mx-10"
                  src={unitellerLogo}
                  alt="UniTeller Logo"
                />
                <img
                  className="h-8 2xl:h-10 w-auto object-contain mx-6 lg:mx-10"
                  src={corpayLogo}
                  alt="Corpay Logo"
                />
                <img
                  className="h-14 2xl:h-16 w-auto object-contain mx-6 lg:mx-10"
                  src={tesoredLogo}
                  alt="TesoRed Logo"
                />
                <img
                  className="h-9 2xl:h-12 w-auto object-contain mx-6 lg:mx-10"
                  src={apprizaLogo}
                  alt="Appriza Logo"
                />
                <img
                  className="h-12 2xl:h-14 w-auto object-contain mx-6 lg:mx-10"
                  src={gytLogo}
                  alt="G&T Logo"
                />
                <img
                  className="h-14 2xl:h-16 w-auto object-contain mx-6 lg:mx-10"
                  src={claroPayLogo}
                  alt="Claro Pay English Logo"
                />
                {lang === "en" ? (
                  <img
                    className="h-[78px] 2xl:h-24 w-auto object-contain mx-6 lg:mx-10"
                    src={finviarEnLogo}
                    alt="Claro Pay English Logo"
                  />
                ) : (
                  <img
                    className="h-[78px] 2xl:h-24 w-auto object-contain mx-6 lg:mx-10"
                    src={finviarEsLogo}
                    alt="Claro Pay Spanish Logo"
                  />
                )}
                <img
                  className="h-20 2xl:h-24 w-auto object-contain mx-6 lg:mx-10"
                  src={interAmericanChamber}
                  alt="Chamber of Commerce Logo"
                />
                <img
                  className="h-20 2xl:h-24 w-auto object-contain mx-6 lg:mx-10"
                  src={northEastChamber}
                  alt="Chamber of Commerce Logo"
                />
                <img
                  className="h-12 md:h-14 2xl:h-16 w-auto object-contain mx-6 lg:mx-10"
                  src={anierm}
                  alt="Anierm Logo"
                />
                <img
                  className="h-12 2xl:h-14 w-auto object-contain mx-6 lg:mx-10"
                  src={costaFarmsLogo}
                  alt="Costa Farms Logo"
                />
                <img
                  className="h-12 2xl:h-14 w-auto object-contain mx-6 lg:mx-10"
                  src={usiLogo}
                  alt="USI Logo"
                />
                <img
                  className="h-12 2xl:h-14 w-auto object-contain mx-6 lg:mx-10"
                  src={martoriLogo}
                  alt="Martori Farms Logo"
                />
                <img
                  className="h-12 2xl:h-14 w-auto object-contain mx-6 lg:mx-10"
                  src={omnibusExpressLogo}
                  alt="Omnibus Express Logo"
                />
                <img
                  className="h-12 2xl:h-14 w-auto object-contain mx-6 lg:mx-10"
                  src={omnibusDeMexicoLogo}
                  alt="Omnibus de México Logo"
                />
              </Marquee>
            </div>
          </div>
        </div>

        <div id="our-solutions" className="bg-sendolab-white2">
          <div className="w-full flex flex-col items-center py-20 max-sm:pt-20 px-6 lg:px-10 bg-[#f9f9f6]">
            <ExploreOurSolutionsBanner />
          </div>
        </div>
      </div>

      <QuoterLegalInfo
        show={showLegalInfo}
        onClose={() => setShowLegalInfo(false)}
      />
    </>
  );
}
